import { render, staticRenderFns } from "./InventarioFlorestal.vue?vue&type=template&id=1cab44cf&scoped=true"
import script from "./InventarioFlorestal.vue?vue&type=script&lang=js"
export * from "./InventarioFlorestal.vue?vue&type=script&lang=js"
import style0 from "./InventarioFlorestal.vue?vue&type=style&index=0&id=1cab44cf&prod&lang=css"
import style1 from "../../../css/crud.css?vue&type=style&index=1&id=1cab44cf&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab44cf",
  null
  
)

export default component.exports